import { createSlice } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const initialState = {
  areas: [],
  selectedArea: null,
  loading: false,
  error: null
}

const parking = createSlice({
  name: 'parking',
  initialState,
  reducers: {
    setAreas (state, action) {
      return {
        ...state,
        areas: action.payload
      }
    },
    setSelectedArea (state, action) {
      return {
        ...state,
        selectedArea: action.payload
      }
    },
    setLoading (state, action) {
      return {
        ...state,
        loading: action.payload
      }
    },
    setError (state, action) {
      const payload = action.payload
      const error = payload == null ? null : (typeof payload === 'string' ? payload : payload?.detail ?? String(payload))
      return {
        ...state,
        error
      }
    }
  }
})

const persistConfig = {
  key: 'parking',
  storage
}

export const { setAreas, setSelectedArea, setLoading, setError } = parking.actions
export const ParkingReducer = persistReducer(persistConfig, parking.reducer)
